import React from 'react';
import InformacioPunt from '../InformacioDePunt/InformacioPunt';
import TaulaCapa from '../TaulaCapa/TaulaCapa';
import {
  InformacioPuntContainer,
  InformacioPuntBar,
  InformacioPuntWrapper,
  BarBtn,
  MinSVG,
  BarDragIcon,
  BarSizeBtnsWrapper,
  BarTitleWrappper,
  BarDragIconWrapper,
  CloseBtnWrapper,
  MaximizeBtnWrapper,
  MinimizeBtnWrapper,
  FullMinimizeBtnWrapper,
  InformacioPuntBarLowerRow,
  InformacioPuntBarUpperRow,
  InfoPuntSVG,
  TabContainer,
  TabInfo,
  TabClose,
  TabIcon,
  TabTitle
} from './InformacioElement';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import Imatges from './Imatges/Imatges';
import { displayComponents } from '../Utils/VisorsUtils';
import StatsComponent from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Estadisticas/Stats';

export default class Informacio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialPos: null, // variable de estado de la posición inicial de la información de punto cuando se empieza en drag
      initialSize: null, // variable de estado de la altura inicial de la información de punto cuando se empieza en drag
      selected: [true],
      prevFotos: []
    };
    this.dragImg = new Image(0, 0);
  }

  componentDidMount() {
    let length = this.props.infoPuntInfo?.length;
    this.initDraggableMovile();
    this.dragImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    this.setState({ selected: new Array(length).fill(false).fill(true, 0, 1) });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.infoPuntInfo !== this.props.infoPuntInfo) {
      let length = this.props.infoPuntInfo?.length;
      this.setState({ selected: new Array(length).fill(false).fill(true, 0, 1) });
    }
  };

  /**
   * @param {*} e
   * @desc Función encargada de crear los eventos de drag en dispositivos con pantalla táctil
   */
  initDraggableMovile = () => {
    // window.addEventListener('load', () => {
    const draggableComponent = document.querySelector('#info-punt-nav');
    if (draggableComponent !== null && draggableComponent !== undefined) {
      draggableComponent.addEventListener('touchstart', this.initialMobile, {
        passive: true
      });
      draggableComponent.addEventListener('touchmove', this.resizeMobile, {
        passive: true
      });
    }
    // }
    // );
  };

  /**
   * @param {*} e
   * @desc Función encargada de inicializar las variables de estado en el inicio de un drag en dispositivos con pantalla táctil
   */
  initialMobile = (e) => {
    this.setState({
      initialPos: e.touches[0].clientY,
      initialSize: this.props.alturaInfoPunt
    });
  };

  /**
   * @param {*} e
   * @desc Función encargada de actualizar la altura de la información de punto según el drag en dispositivos con pantalla táctil
   */
  resizeMobile = (e) => {
    e.preventDefault();
    if (e.touches[0].clientY > 80 && e.touches[0].clientY < window.innerHeight) {
      let num = parseInt(this.state.initialSize) - parseInt(e.touches[0].clientY - this.state.initialPos);
      if (num > 35) {
        this.props.onResizeInfoPuntCard(num);
      }
    }
  };

  /**
   * @param {*} e
   * @desc Función encargada de inicializar las variables de estado en el inicio de un drag en desktop
   */
  initial = (e) => {
    e.dataTransfer.setDragImage(new Image(), 0, 0);
    this.setState({
      initialPos: e.clientY,
      initialSize: this.props.alturaInfoPunt
    });
  };

  /**
   * @param {*} e
   * @desc Función encargada de actualizar la altura de la información de punto según el drag en desktop
   */
  resize = (e) => {
    if (e.clientY > 0 && !this.props.cercaOpen && !this.props.cercaAvançada) {
      this.props.onResizeInfoPuntCard(parseInt(this.state.initialSize) - parseInt(e.clientY - this.state.initialPos));
    }
  };

  responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1023, min: 568 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 567, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  closeGallery = (e) => {
    this.setState({ prevFotos: this.props.fotos }, () => {
      this.props.closeThumbnails(e);
    });
  };

  closeStats = (e) => {
    this.props.closeStatsTab(e);
  };

  render() {
    return (
      <InformacioPuntContainer
        id="taula-container"
        altura={this.props.alturaInfoPunt + 'px'}
        height={this.props.alturaInfoPunt}
        width={window.innerWidth}
        open={this.props.isOpen}>
        <InformacioPuntWrapper altura={this.props.alturaInfoPunt + 'px'} displayInfoPuntBody={this.props.displayInfoPuntBody}>
          <InformacioPuntBar
            id="info-punt-nav"
            alturaInfoPunt={this.props.alturaInfoPunt}
            draggable="true"
            onDragStart={this.initial}
            onDrag={this.resize}>
            <InformacioPuntBarUpperRow>
              <BarDragIconWrapper>
                <BarDragIcon id="drag-icon"></BarDragIcon>
              </BarDragIconWrapper>
            </InformacioPuntBarUpperRow>
            <InformacioPuntBarLowerRow>
              <BarTitleWrappper>
                {/* TAB DE INFO PUNT */}
                {this.props.coords && (
                  <TabContainer
                    fontSizeEnabled={this.props.fontSizeEnabled}
                    enabled={this.props.coords}
                    title={getTranslatedKey('infoPunt')}
                    onClick={() => this.props.tableInfoToggle('info')}>
                    <TabInfo selected={this.props.infoPuntObert}>
                      <TabIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="18"
                          viewBox="0 0 512 512"
                          fill={this.props.infoPuntObert ? '#febf00' : 'white'}>
                          <path d="M255.8,507c-13.8,0-26.6-6.2-35.1-17.1l-51.1-64.9L80,425c-44.1,0-80-35.9-80-80V84C0,39.9,35.9,4,80,4h352  c44.1,0,80,35.9,80,80v256.5c0,11-9,20-20,20s-20-9-20-20V84c0-22.1-17.9-40-40-40H80c-22.1,0-40,17.9-40,40v261  c0,22.1,17.9,40,40,40l99.4,0.1c6.1,0,11.9,2.8,15.7,7.6l57.2,72.5c1.2,1.5,2.6,1.8,3.6,1.8h0c1,0,2.4-0.3,3.6-1.8  c0,0,0.1-0.1,0.1-0.1l56.7-72.4c3.8-4.8,9.6-7.7,15.7-7.7h100c22.1,0,40-17.9,40-40c0-11,9-20,20-20s20,9,20,20  c0,44.1-35.9,80-80,80h-90.3l-50.7,64.7c-8.5,10.9-21.2,17.2-35,17.3C256,507,255.9,507,255.8,507z M279.5,335.6V209.4  c0-12.9-10.5-23.4-23.4-23.4c-12.9,0-23.4,10.5-23.4,23.4v126.2c0,12.9,10.5,23.4,23.4,23.4C269.1,359,279.5,348.5,279.5,335.6z   M255.7,103c-14.4,0-26.1,11.7-26.1,26.1s11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1S270.1,103,255.7,103z" />
                        </svg>
                      </TabIcon>

                      {window.innerWidth > 750 && <TabTitle>{window.innerWidth > 930 ? 'INFORMACIÓ PUNT' : 'PUNT'}</TabTitle>}
                    </TabInfo>
                    <TabClose onClick={(e) => this.props.closeInfoTab(e)}>
                      <svg
                        viewBox="0 0 24 24"
                        fill={this.props.infoPuntObert ? '#febf00' : 'white'}
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        x="0px"
                        y="0px"
                        width="18"
                        class="sc-iyFuvt">
                        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                      </svg>
                    </TabClose>
                  </TabContainer>
                )}
                {/* TAB DE LA GALERIA */}
                {this.props.fotos.length > 0 && window.innerWidth > 768 && displayComponents.galeria && (
                  <TabContainer
                    enabled={this.props.fotos.length > 0}
                    title={getTranslatedKey('galeria')}
                    onClick={() => (this.props.coords ? this.props.tableInfoToggle('thumbnails') : null)}>
                    <TabInfo selected={this.props.thumbnailsOpen}>
                      <TabIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill={this.props.thumbnailsOpen ? '#febf00' : 'white'}
                          version="1.1"
                          id="Capa_1"
                          x="0px"
                          y="0px"
                          width="18"
                          viewBox="0 0 548.176 548.176">
                          <g>
                            <g>
                              <path d="M534.75,68.238c-8.945-8.945-19.694-13.417-32.261-13.417H45.681c-12.562,0-23.313,4.471-32.264,13.417    C4.471,77.185,0,87.936,0,100.499v347.173c0,12.566,4.471,23.318,13.417,32.264c8.951,8.946,19.702,13.419,32.264,13.419h456.815    c12.56,0,23.312-4.473,32.258-13.419c8.945-8.945,13.422-19.697,13.422-32.264V100.499    C548.176,87.936,543.699,77.185,534.75,68.238z M511.623,447.672c0,2.478-0.899,4.613-2.707,6.427    c-1.81,1.8-3.952,2.703-6.427,2.703H45.681c-2.473,0-4.615-0.903-6.423-2.703c-1.807-1.813-2.712-3.949-2.712-6.427V100.495    c0-2.474,0.902-4.611,2.712-6.423c1.809-1.803,3.951-2.708,6.423-2.708h456.815c2.471,0,4.613,0.905,6.42,2.708    c1.801,1.812,2.707,3.949,2.707,6.423V447.672L511.623,447.672z" />
                              <path d="M127.91,237.541c15.229,0,28.171-5.327,38.831-15.987c10.657-10.66,15.987-23.601,15.987-38.826    c0-15.23-5.333-28.171-15.987-38.832c-10.66-10.656-23.603-15.986-38.831-15.986c-15.227,0-28.168,5.33-38.828,15.986    c-10.656,10.66-15.986,23.601-15.986,38.832c0,15.225,5.327,28.169,15.986,38.826C99.742,232.211,112.683,237.541,127.91,237.541z    " />
                              <polygon points="210.134,319.765 164.452,274.088 73.092,365.447 73.092,420.267 475.085,420.267 475.085,292.36 356.315,173.587       " />
                            </g>
                          </g>
                        </svg>
                      </TabIcon>
                      {window.innerWidth > 750 && <TabTitle>GALERIA</TabTitle>}
                    </TabInfo>
                    <TabClose onClick={(e) => this.closeGallery(e)}>
                      <svg
                        viewBox="0 0 24 24"
                        fill={this.props.thumbnailsOpen ? '#febf00' : 'white'}
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        x="0px"
                        y="0px"
                        width="18"
                        class="sc-iyFuvt">
                        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                      </svg>
                    </TabClose>
                  </TabContainer>
                )}
                {/* TAB DE LA TABLA */}
                {Object.keys(this.props.taulaArray).length > 0 && displayComponents.taulaDadesCapa && (
                  <TabContainer
                    title={getTranslatedKey('taulaCapa')}
                    enabled={Object.keys(this.props.taulaArray).length > 0}
                    onClick={() => this.props.tableInfoToggle('table')}>
                    <TabInfo selected={this.props.taulaCapaObert}>
                      <TabIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="18"
                          fill={this.props.taulaCapaObert ? '#febf00' : 'white'}
                          viewBox="0 0 24 24">
                          <path d="M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z"></path>
                        </svg>
                      </TabIcon>
                      {window.innerWidth > 750 && <TabTitle>{window.innerWidth > 930 ? 'TAULA DE DADES' : 'TAULA'}</TabTitle>}
                    </TabInfo>
                    <TabClose onClick={(e) => this.props.closeAllTabs(e)}>
                      <svg
                        viewBox="0 0 24 24"
                        fill={this.props.taulaCapaObert ? '#febf00' : 'white'}
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        x="0px"
                        y="0px"
                        width="18"
                        class="sc-iyFuvt">
                        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                      </svg>
                    </TabClose>
                  </TabContainer>
                )}
                {/* TAB ESTADÍSTIQUES */}
                {this.props.statsLayer && displayComponents.statsCapa && (
                  <TabContainer long title={getTranslatedKey('layerStats')} enabled={true} onClick={() => this.props.tableInfoToggle('stats')}>
                    <TabInfo selected={this.props.statsOpen}>
                      <TabIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill={this.props.statsOpen ? '#febf00' : 'white'}
                          width="22"
                          version="1.1"
                          id="Capa_1"
                          viewBox="0 0 512 512">
                          <g>
                            <g>
                              <path d="M226,240h-60c-8.3,0-15,6.7-15,15v197h90V255C241,246.7,234.3,240,226,240z"></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M346,300h-60c-8.3,0-15,6.7-15,15v137h90V315C361,306.7,354.3,300,346,300z"></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M466,180h-60c-8.3,0-15,6.7-15,15v257h90V195C481,186.7,474.3,180,466,180z"></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M106,330H46c-8.3,0-15,6.7-15,15v107h90V345C121,336.7,114.3,330,106,330z"></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M497,482c-67,0-97.7,0-109.9,0c-5.5,0-7.5,0-7.5,0c-22.1,0-104.4,0-364.6,0c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15    c181.5,0,312.4,0,482,0c8.3,0,15-6.7,15-15S505.3,482,497,482z"></path>
                            </g>
                          </g>
                        </svg>
                      </TabIcon>
                      {window.innerWidth > 750 && <TabTitle>ESTADÍSTIQUES</TabTitle>}
                    </TabInfo>
                    <TabClose onClick={(e) => this.closeStats(e)}>
                      <svg
                        viewBox="0 0 24 24"
                        fill={this.props.statsOpen ? '#febf00' : 'white'}
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        y="5px"
                        width="18">
                        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                      </svg>
                    </TabClose>
                  </TabContainer>
                )}
              </BarTitleWrappper>
              <BarSizeBtnsWrapper id="info-punt-resize-buttons">
                {this.props.buttonsActive && (
                  <>
                    {this.props.alturaInfoPunt > 25 && window.innerWidth > 460 ? (
                      <FullMinimizeBtnWrapper onClick={() => this.props.onClickInfoPunt('fullMin')}>
                        <BarBtn>
                          <MinSVG>
                            <svg x="-10" y="-32">
                              <path transform="scale(1.4,1.4)" d="m44 42h-24a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z" />
                            </svg>
                          </MinSVG>
                        </BarBtn>
                      </FullMinimizeBtnWrapper>
                    ) : null}
                    {this.props.alturaInfoPunt >= (window.innerWidth > 768 ? (window.innerHeight - 40) / 3 : (window.innerHeight - 80) / 3) &&
                    window.innerWidth > 460 ? (
                      <MinimizeBtnWrapper>
                        <BarBtn title={getTranslatedKey('minimize')} onClick={() => this.props.onClickInfoPunt('min')}>
                          <InfoPuntSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 330 330" fill="#fff">
                            <path
                              d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
	                      c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
	                      s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                            />
                          </InfoPuntSVG>
                        </BarBtn>
                      </MinimizeBtnWrapper>
                    ) : null}
                    {this.props.alturaInfoPunt <= ((window.innerHeight - 80) / 3) * 2 && window.innerWidth > 460 ? (
                      <MaximizeBtnWrapper>
                        <BarBtn title={getTranslatedKey('maximize')} onClick={() => this.props.onClickInfoPunt('max')}>
                          <InfoPuntSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 330 330" fill="#fff">
                            <path
                              d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
                        c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
                        s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                            />
                          </InfoPuntSVG>
                        </BarBtn>
                      </MaximizeBtnWrapper>
                    ) : null}
                  </>
                )}
                <CloseBtnWrapper>
                  <BarBtn title={getTranslatedKey('tancar')} onClick={(e) => this.props.onClickInfoPunt('close', e)}>
                    <InfoPuntSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="#fff">
                      <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </InfoPuntSVG>
                  </BarBtn>
                </CloseBtnWrapper>
              </BarSizeBtnsWrapper>
            </InformacioPuntBarLowerRow>
          </InformacioPuntBar>

          {this.props.infoPuntObert && (displayComponents.infoCapa || displayComponents.infoPuntInfo) && (
            <InformacioPunt
              editCardProps={this.props.editCardProps}
              showEditCard={this.props.showEditCard}
              apiEnabled={this.props.apiEnabled}
              apiFunctions={this.props.apiFunctions}
              toggleAlert={this.props.toggleAlert}
              editFeature={this.props.editFeature}
              editVector={this.props.editVector}
              setEditing={this.props.setEditing}
              isEditing={this.props.isEditing}
              favList={this.props.favList}
              favFeatureInfo={this.props.favFeatureInfo}
              addToFav={this.props.addToFav}
              prevFotos={this.state.prevFotos}
              setFotos={this.props.setFotos}
              toggleGaleria={this.props.toggleGaleria}
              closeAllTabs={this.props.closeAllTabs}
              closeInfoPunt={this.props.closeInfoPunt}
              table={Object.keys(this.props.taulaArray).length > 0}
              tableInfoToggle={this.props.tableInfoToggle}
              taulaFc={this.props.taulaFc}
              taulaLoading={this.props.taulaLoading}
              taulaTotal={this.props.taulaTotal}
              updateTablePage={this.props.updateTablePage}
              taulaPage={this.props.taulaPage}
              taulaLayer={this.props.taulaLayer}
              taulaFilters={this.props.taulaFilters}
              getTaulaArray={this.props.getTaulaArray}
              taulaArray={this.props.taulaArray}
              alturaInfoPunt={this.props.alturaInfoPunt}
              coords={this.props.coords}
              map={this.props.map}
              selected={this.state.selected}
              onClickInfoPunt={(operacio) => this.props.onClickInfoPunt(operacio)}
              onResizeInfoPuntCard={(newInfoCardHeigth) => this.props.onResizeInfoPuntCard(newInfoCardHeigth)}
              isOpen={this.props.infoPuntObert}
              featureCollect={this.props.featureCollect}
              displayInfoPuntBody={this.props.displayInfoPuntBody}
              infoPuntInfo={this.props.infoPuntInfo}
              nCards={this.props.nCards}
              layersSelectedOnClick={this.props.layersSelectedOnClick}
              featureOverlay={this.props.featureOverlay}
              arrayLayers={this.props.arrayLayers}
              municipi={this.props.municipi}
              carrer={this.props.carrer}
              alçada={this.props.alçada}
              fontSizeEnabled={this.props.fontSizeEnabled}
            />
          )}
          {this.props.taulaCapaObert && displayComponents.taulaDadesCapa && (
            <TaulaCapa
              taulaSorting={this.props.taulaSorting}
              setTaulaSorting={this.props.setTaulaSorting}
              getExternTable={this.props.getExternTable}
              taulaSpacialBbox={this.props.taulaSpacialBbox}
              scrollToFiltre={this.props.scrollToFiltre}
              taulaFullFilter={this.props.taulaFullFilter}
              closeAllTabs={this.props.closeAllTabs}
              closeInfoPunt={this.props.closeInfoPunt}
              tableInfoToggle={this.props.tableInfoToggle}
              deleteTaula={this.props.deleteTaula}
              getTaulaArray={this.props.getTaulaArray}
              onClickInfoPunt={this.props.onClickInfoPunt}
              onResizeInfoPuntCard={(newInfoCardHeigth) => this.props.onResizeInfoPuntCard(newInfoCardHeigth)}
              setTaulaLayer={this.props.setTaulaLayer}
              changeLlegendaOpen={this.props.changeLlegendaOpen}
              updateTablePage={this.props.updateTablePage}
              alçada={this.props.municipi}
              taulaFc={this.props.taulaFc}
              taulaLoading={this.props.taulaLoading}
              taulaTotal={this.props.taulaTotal}
              taulaPage={this.props.taulaPage}
              taulaGeom={this.props.taulaGeom}
              taulaLayer={this.props.taulaLayer}
              taulaFilters={this.props.taulaFilters}
              taulaArray={this.props.taulaArray}
              alturaInfoPunt={this.props.alturaInfoPunt}
              coords={this.props.clickCoords}
              map={this.props.map}
              isOpen={this.props.taulaCapaObert}
              featureCollect={this.props.featureCollect}
              infoPuntInfo={this.props.infoPuntInfo}
              featureOverlay={this.props.featureOverlay}
              arrayLayers={this.props.arrayLayers}
              fontSizeEnabled={this.props.fontSizeEnabled}
            />
          )}
          {this.props.statsOpen && this.props.statsLayer && (
            <StatsComponent
              alturaInfoPunt={this.props.alturaInfoPunt}
              key={this.props.statsLayer}
              layer={this.props.statsLayer}
              statsValue={this.props.statsValue}
              taulaFullFilter={this.props.taulaFullFilter}
            />
          )}
          {this.props.thumbnailsOpen && (
            <Imatges toggleGaleria={this.props.toggleGaleria} fotos={this.props.fotos} alturaInfoPunt={this.props.alturaInfoPunt} />
          )}
        </InformacioPuntWrapper>
      </InformacioPuntContainer>
    );
  }
}
